import React from "react";
import { AbstractDate, DateMath } from "@linkfluence/models/date";
import { Timezone } from "@linkfluence/models/timezone";
import Subtitle from "@radarly/components/cards/card/subtitle";
import Date from "@radarly/components/cards/card/subtitle/date";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { Clause } from "@radarly/models/clause";
import { PanelPostsClauseRecap } from "./clause-recap";

interface PanelPostsSubtitleProps {
  isLoading: boolean;
  focusClause: Clause;
  total: number;
  from: AbstractDate;
  to?: AbstractDate;
  timezone: Timezone;
}

export function PanelPostsSubtitle({
  isLoading,
  total,
  focusClause,
  from,
  timezone,
  to = DateMath.Now,
}: PanelPostsSubtitleProps) {
  const locale = useCurrentUserLocale();
  return (
    <Subtitle
      meta={[
        <Date from={from} to={to} locale={locale} timezone={timezone} />,
        <PanelPostsClauseRecap
          isLoading={isLoading}
          total={total}
          focusClause={focusClause}
          dateFrom={from}
          dateTo={to}
        />,
      ]}
    />
  );
}
